class KosasSocialVideo extends HTMLElement {
  connectedCallback() {
    this.videos = [...this.querySelectorAll('video')];
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const video = entry.target;
        if (entry.isIntersecting && !this.reducedMotion && video.dataset.userPaused !== 'true') {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
        this.updateButton(video);
      }
    }, { threshold: 0.55 });

    for (const video of this.videos) this.observer.observe(video);
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    const button = event.target.closest('[data-kosas-video-toggle]');
    if (!button) return;
    const video = button.closest('.kosas-social-card')?.querySelector('video');
    if (!video) return;

    if (video.paused) {
      video.dataset.userPaused = 'false';
      video.play().catch(() => {});
    } else {
      video.dataset.userPaused = 'true';
      video.pause();
    }
    this.updateButton(video);
  };

  updateButton(video) {
    const card = video.closest('.kosas-social-card');
    const button = card?.querySelector('[data-kosas-video-toggle]');
    if (!button) return;
    const paused = video.paused;
    button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    button.dataset.paused = String(paused);
  }
}

if (!customElements.get('kosas-social-video')) {
  customElements.define('kosas-social-video', KosasSocialVideo);
}
